import { useCallback } from 'react';
import { Onboarding } from '../../../components/onboarding/Onboarding';
import RootLayout from '../../layouts/RootLayout';
import API from '../../../lib/api';
import { useNavigate, useSearchParams } from 'react-router';

export default function OnboardingPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const handleComplete = useCallback(() => {

        if (searchParams.get('ref') === 'zaciname') {
            navigate('/zaciname');
            return;
        }
        console.log('Onboarding completed!');
        // Redirect to dashboard or main app
        API.post('/user/onboarding')
            .then(() => {
                navigate('/dashboard');
            })
            .catch((err) => {
                console.log(err);
            });
    }, [navigate, searchParams]);

    return (
        <RootLayout>
            <Onboarding onComplete={handleComplete} />
        </RootLayout>
    );
}
